import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import useWindowSize from "shared/customHooks/windowSize";
import { planCategories } from "../constant";
import SkeletonLoader from "../skeletonLoader";
import styles from "./../style.module.scss";
import {
  plan_level_enums,
  plans_types_enums,
} from "shared/modals/managePlans/constant";

function PlansTable({
  activeTab,
  setIsSchoolTabSelected,
  handleOpenForm,
  dataLoader,
  allPlans,
  setViewOnly,
  setEditOnly,
  handleOpenConfirmation,
  setOpenAdd,
  setSelectedItem,
  setSelectedPlan,
}: any) {
  const screenWidth = useWindowSize();
  console.log(allPlans?.[0]?.duration, "data for all plans");
  return (
    <Box className={styles.topLevelContainer}>
      <TableContainer
        component={Paper}
        className={styles.container}
        sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
      >
        <Table className={styles.table} aria-label="simple table">
          <TableHead>
            <TableRow className={styles.tableHead}>
              {activeTab === 3 ? <TableCell>School Name</TableCell> : null}
              <TableCell>Plan Title</TableCell>
              <TableCell>Amount</TableCell>
              {activeTab !== 3 && <TableCell>Coins</TableCell>}
              <TableCell>Duration</TableCell>
              <TableCell>Discount</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataLoader ? (
              <SkeletonLoader activeTab={activeTab} />
            ) : (
              allPlans
                ?.filter((item: any) => item?.category === activeTab)
                .map((item: any) => {
                  return (
                    <>
                      <TableRow className={styles.tableRow}>
                        {activeTab === 3 ? (
                          <TableCell>
                            {item?.school_name ? item?.school_name : "--"}
                          </TableCell>
                        ) : null}
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "7px",
                            }}
                          >
                            {item?.name ? item?.name : "--"}
                            {activeTab !== 3 && item?.in_app ? (
                              <Icons.InAppIcon />
                            ) : null}
                            {item?.type === plans_types_enums.promotional && (
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill={
                                  item?.status === 0 || item?.status === 2
                                    ? "#9E9E9E"
                                    : "#FFC107"
                                }
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M12 0l2.47 5.53L20 4l-1.53 5.53L24 12l-5.53 2.47L20 20l-5.53-1.53L12 24l-2.47-5.53L4 20l1.53-5.53L0 12l5.53-2.47L4 4l5.53 1.53z" />
                              </svg>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          {item?.currency_type && item?.currency_type !== "PKR"
                            ? "$"
                            : "Rs."}
                          {item?.price}{" "}
                        </TableCell>
                        {activeTab !== 3 && (
                          <TableCell>{item?.coins}</TableCell>
                        )}
                        <TableCell>
                          {item?.duration > 1
                            ? item?.duration + " Months"
                            : item?.duration + " Month"}
                        </TableCell>

                        <TableCell>
                          {item?.is_discounted ? "Available" : "Not Available"}
                        </TableCell>

                        <TableCell>
                          <div className={styles.actionContainer}>
                            <Tooltip
                              componentsProps={{
                                tooltip: { className: "tooltip" },
                                arrow: { className: "arrow" },
                              }}
                              placement="top"
                              arrow
                              title="View"
                            >
                              <div
                                onClick={() => {
                                  handleOpenForm(item);
                                  setViewOnly(true);
                                  setEditOnly(false);
                                }}
                              >
                                <Icons.EyeIcon2 />
                              </div>
                            </Tooltip>
                            {activeTab !== 3 && (
                              <Tooltip
                                componentsProps={{
                                  tooltip: { className: "tooltip" },
                                  arrow: { className: "arrow" },
                                }}
                                placement="top"
                                arrow
                                title="Edit"
                              >
                                <div
                                  onClick={() => {
                                    if (activeTab === planCategories.school) {
                                      setIsSchoolTabSelected(true);
                                    } else {
                                      setIsSchoolTabSelected(false);
                                    }
                                    // handleOpenForm(item);
                                    setEditOnly(true);
                                    setOpenAdd(true);
                                    setSelectedItem(item);
                                    // setSelectedPlan(item);
                                  }}
                                >
                                  <Icons.CreateActionIcon />
                                </div>
                              </Tooltip>
                            )}
                            <Tooltip
                              componentsProps={{
                                tooltip: { className: "tooltip" },
                                arrow: { className: "arrow" },
                              }}
                              placement="top"
                              arrow
                              title={`${
                                item?.status ? "Dectivate" : "Activate"
                              }`}
                            >
                              <div
                                onClick={() =>
                                  handleOpenConfirmation(
                                    `Are you sure you want to ${
                                      item?.status === 1
                                        ? "inactivate"
                                        : "activate"
                                    } this plan?`,
                                    `${
                                      item?.status === 0 || item?.status === 2
                                        ? "active"
                                        : item?.status === 1
                                          ? "inactive"
                                          : ""
                                    }`,
                                    item,
                                  )
                                }
                              >
                                <Icons.LightningIcon
                                  className={
                                    item?.status === 0
                                      ? styles.inactiveIcon
                                      : styles?.activeIcon
                                  }
                                />
                              </div>
                            </Tooltip>
                            {activeTab !== 3 && (
                              <Tooltip
                                componentsProps={{
                                  tooltip: { className: "tooltip" },
                                  arrow: { className: "arrow" },
                                }}
                                placement="top"
                                arrow
                                title="Delete"
                              >
                                <div
                                  onClick={() =>
                                    handleOpenConfirmation(
                                      "Are you sure, you want to delete this plan?",
                                      "delete",
                                      item,
                                    )
                                  }
                                >
                                  <Icons.DeleteIcon />
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box>
        {dataLoader ? null : allPlans?.filter(
          (plan: any) => plan.category === planCategories.school,
        ).length === 0 && activeTab === planCategories.school ? (
          <NoDataCard />
        ) : allPlans?.filter(
            (plan: any) => plan.category === planCategories.individual,
          ).length === 0 && activeTab === planCategories.individual ? (
          <NoDataCard />
        ) : allPlans?.filter(
            (plan: any) => plan.category === planCategories.family,
          ).length === 0 && activeTab === planCategories.family ? (
          <NoDataCard />
        ) : null}
      </Box>
    </Box>
  );
}

const NoDataCard = () => {
  return (
    <div className={classNames(styles.noDataCard, styles.noData)}>
      <Icons.NoDataIcon />
      <h5>No Data Found</h5>
    </div>
  );
};

export default PlansTable;
